"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntitySelectMultiValueWithDescriptions = exports.EntitySelectMultiValue = exports.EntitySelectMultiValueDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_value_1 = require("./entity-value");
var react_select_1 = require("react-select");
var html_1 = require("../elements/html");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var menu_context_1 = require("../context/menu-context");
var lodash_1 = require("lodash");
var icons_1 = require("../icons");
var to_array_1 = require("../../utils/to-array");
exports.EntitySelectMultiValueDefaultProps = {
  showDescription: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    padding: ", " ", " ", " ", ";\n    flex-direction: column;\n  "], ["\n    display: flex;\n    padding: ", " ", " ", " ", ";\n    flex-direction: column;\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1), theme_1.theme.UNIT(1, -1))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n\n    /* ", " */\n  "], ["\n    flex-wrap: nowrap;\n    flex-shrink: 0;\n\n    /* ", " */\n  "])), function (_a) {
    var hasIndent = _a.hasIndent;
    return hasIndent && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme_1.theme.UNIT(1));
  })
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    font-size: ", ";\n    padding-top: ", ";\n  "], ["\n    color: ", ";\n    font-size: ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.FONT_SIZE(13), theme_1.theme.UNIT(3))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Description: (0, styled_components_1.default)(html_1.HTML)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
var EntitySelectMultiValue = function (props) {
  var className = props.className,
    data = props.data,
    selectProps = props.selectProps;
  var entity = data.entity;
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var hasIndent = defn.valueImageStyle === 'banner';
  var select = defn.select;
  var badge = select.optionBadge(data);
  var menuContext = (0, menu_context_1.useMenuContext)();
  var currentValue = (0, to_array_1.toArray)(selectProps.value);
  var selectLength = (0, lodash_1.size)(currentValue);
  var currentIndex = currentValue.length && currentValue.findIndex(function (item) {
    return item.value === data.value;
  });
  var moveToStart = function () {
    var newValue = __spreadArray([data], __read((0, lodash_1.filter)(currentValue, function (item) {
      return item.value !== data.value;
    })), false);
    if (selectProps.onChange) {
      selectProps.onChange(newValue);
    }
  };
  var moveToEnd = function () {
    var newValue = __spreadArray(__spreadArray([], __read((0, lodash_1.filter)(currentValue, function (item) {
      return item.value !== data.value;
    })), false), [data], false);
    if (selectProps.onChange) {
      selectProps.onChange(newValue);
    }
  };
  var moveBack = function () {
    var newValue = __spreadArray([], __read((0, lodash_1.filter)(currentValue, function (item) {
      return item.value !== data.value;
    })), false);
    newValue.splice(currentIndex - 1, 0, data);
    if (selectProps.onChange) {
      selectProps.onChange(newValue);
    }
  };
  var moveForward = function () {
    var newValue = __spreadArray([], __read((0, lodash_1.filter)(currentValue, function (item) {
      return item.value !== data.value;
    })), false);
    newValue.splice(currentIndex + 1, 0, data);
    if (selectProps.onChange) {
      selectProps.onChange(newValue);
    }
  };
  return /* @ts-ignore */react_1.default.createElement(react_select_1.components.MultiValue, __assign({}, props), react_1.default.createElement(menu_context_1.MenuProvider, {
    value: __assign(__assign({}, menuContext), {
      extraItems: (0, lodash_1.filter)([{
        disabled: selectLength <= 1 || currentIndex === 0,
        label: "Move Item to Start",
        value: "START",
        icon: react_1.default.createElement(icons_1.Icons.ChevronDoubleLeft, null),
        onClick: moveToStart
      }, {
        disabled: selectLength <= 1 || currentIndex === 0,
        label: "Move Item Backward",
        value: "BACK",
        icon: react_1.default.createElement(icons_1.Icons.ChevronLeft, null),
        onClick: moveBack
      }, {
        disabled: selectLength <= 1 || currentIndex === selectLength - 1,
        label: "Move Item Forward",
        value: "FORWARD",
        icon: react_1.default.createElement(icons_1.Icons.ChevronRight, null),
        onClick: moveForward
      }, {
        disabled: selectLength <= 1 || currentIndex === selectLength - 1,
        label: "Move Item to End",
        value: "END",
        icon: react_1.default.createElement(icons_1.Icons.ChevronDoubleRight, null),
        onClick: moveToEnd
      }])
    })
  }, react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Value, {
    showMenu: true,
    hasIndent: hasIndent,
    badge: badge,
    variant: "small",
    entity: entity
  }))));
};
exports.EntitySelectMultiValue = EntitySelectMultiValue;
var EntitySelectMultiValueWithDescriptions = function (props) {
  return react_1.default.createElement(exports.EntitySelectMultiValue, __assign({}, props, {
    showDescription: true
  }));
};
exports.EntitySelectMultiValueWithDescriptions = EntitySelectMultiValueWithDescriptions;
exports.EntitySelectMultiValue.defaultProps = exports.EntitySelectMultiValueDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;